import React, { useState } from 'react';
import InviteOthers from '../popups/InviteOthers';
const CommunityAbout = () => {
  const communityDetails = JSON.parse(localStorage.getItem('communityData'));
  const [isInvite, setIsInvite] = useState(false);
  const handleInviteClose = () => setIsInvite(false);
  return (

    <div className="rightbar">

      <div className='about-content'>
        <h4 className='rightbar-heading' >About</h4>
        <p className='rightbar-descr' >{communityDetails?.about}</p>
        <div className='invite'>
          <button className='main-btn w-100' onClick={() => setIsInvite(true)} >Invite others like you</button>
        </div>
      </div>

      {isInvite && <InviteOthers isInvite={isInvite} handleClose={handleInviteClose} />}

    </div>

  );


};
export default CommunityAbout;